import Modal from 'LuxKit/Modal/Modal'
import React, { useCallback, useMemo, useRef } from 'react'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { semiFormToObject } from 'lib/forms/formUtils'
import useQueryParams from 'hooks/useQueryParams'
import Group from 'components/utils/Group'
import CheckboxInput from 'LuxKit/Checkbox/CheckboxInput'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import CruiseCruiseTypeFilter from 'components/Cruises/SearchPage/Filters/Inputs/Common/CruiseSearchExtraFilter/CruiseCruiseTypeFilter'
import {
  CruiseSearchCruiseTypeChipProps,
} from 'components/Cruises/SearchPage/Filters/Inputs/CruiseSearchMobileChips/CruiseSearchCruiseTypeChip'

function ModalCruiseSearchCruiseTypeChip(props: CruiseSearchCruiseTypeChipProps) {
  const {
    facets,
    filterForm,
    setFilterForm,
    fetching,
    filters,
    drawerMode,
  } = props
  const modalElement = useModalElementContext<number>()
  const containerRef = useRef<HTMLDivElement>(null)
  const queryParams = useQueryParams()

  const countSelected = useMemo(() => {
    return queryParams.getAll('cruiseTypes').length
  }, [queryParams])

  const closeModal = useCallback(() => {
    modalElement.resolve(countSelected)
  }, [countSelected, modalElement])

  const updateForm = useCallback(() => {
    const formValues = semiFormToObject<Record<string, any>>(containerRef.current!)
    if (formValues && Object.keys(formValues).length > 0) {
      setFilterForm({
        ...filterForm,
        cruiseTypes: formValues.cruiseTypes,
      })
    } else {
      setFilterForm({
        ...filterForm,
        cruiseTypes: undefined,
      })
    }
  }, [filterForm, setFilterForm])

  const resetFilter = useCallback(() => {
    setFilterForm({
      ...filterForm,
      cruiseTypes: undefined,
    })
    modalElement.resolve(0)
  }, [filterForm, setFilterForm, modalElement])

  return <Modal
    mode={drawerMode ? 'drawer' : 'default'}
    ref={containerRef}
    title="Cruise Type"
    primaryActionText="Apply"
    onPrimaryActionClick={closeModal}
    secondaryActionText={countSelected > 0 ? `Reset all (${countSelected})` : 'Reset all'}
    onSecondaryActionClick={resetFilter}
  >
    {fetching && <Group direction="vertical" gap={8}>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
      <CheckboxInput size="large"><TextLoadingBox width="100%" /></CheckboxInput>
    </Group>}
    {!fetching && <CruiseCruiseTypeFilter
      cruiseTypes={filters.cruiseTypes}
      onChange={updateForm}
      facets={facets}
    />}
  </Modal>
}

export default ModalCruiseSearchCruiseTypeChip
